const ka = {
    common: {
        history: "ისტორიული ვერსია"
    }
};
export default ka;



// WEBPACK FOOTER //
// ./src/i18n/langs/ka.js